var __jsx = React.createElement;
import React from "react";
import classNames from "classnames";
import Button from "../common/Button";
import { useTranslation } from "react-i18next";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
var Footer = function Footer(props) {
  var hasFilesSelected = props.hasFilesSelected,
    onAddFile = props.onAddFile,
    onUpload = props.onUpload,
    disableUpload = props.disableUpload,
    isLoading = props.isLoading,
    isFileUploadHidden = props.isFileUploadHidden;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("flex justify-center sm:justify-end items-center", {
      hidden: !hasFilesSelected || isFileUploadHidden
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full items-center justify-end m-5"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "px-8 py-4 sm:grow-0 flex-1 whitespace-nowrap",
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.DICOM_ADD_MORE_FILES);
      onAddFile();
    },
    "data-testid": "add-files-button"
  }, t("import_scan_secondary")), /*#__PURE__*/React.createElement(Button, {
    isPrimary: true,
    className: "px-8 py-4 sm:grow-0 flex-1 ml-4",
    onClick: onUpload,
    disabled: disableUpload,
    isLoading: isLoading,
    "data-testid": "import-scans-button"
  }, t("import_scan_primary"))));
};
export default Footer;